import React from "react";
import { withStyles,makeStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import {Card, CardTitle} from "reactstrap";
import {DetailLink} from "codeArt/components/Button";
import { Util, createIcon } from "../../../common";
import { Divider } from "@material-ui/core";


const useStyles = makeStyles({
  hollow: props => ({
    background:"transparent !important",
    paddingLeft:"0 !important",
    paddingRight:"0 !important",
    paddingTop:"0 !important",
    paddingBottom:"0 !important",
    "& >div:first-child":{
      paddingLeft:"30px !important",
      paddingRight:"30px !important",
    }
  }),
  flat: props => ({
    paddingLeft:"0 !important",
    paddingRight:"0 !important",
    paddingTop:"0 !important",
    paddingBottom:"0 !important"
  }),
  titleBetween: props => ({
    "& >div:first-child":{
      paddingLeft:"0px !important",
      paddingRight:"0px !important",
    }
  }),
});


const Widget = ({children, className, title,onClick}) => {

  return (
    <Card className={`jr-card jr-card-widget ${className}`} onClick={onClick}>
      {title ? <CardTitle>{title}</CardTitle> : null}
      {children}
    </Card>
  )
};

export default Widget;
Widget.defaultProps = {
  className: '',
};

Widget.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};


const renderTool = (tool,click)=>{
  if(!tool) return null;
  if(Util.type(tool) == "string") return <DetailLink onClick={() => { if (click) click(); }}>{tool}</DetailLink>;
  return tool;
}

const Board = ({ left,title, children, empty, tip,go, goClick,to,toClick, className,icon,iconColor,iconClassName,titleContainerClassName,titleClassName,solid,flat,titleLine,bodyClassName,emptyClassName,titleBetween,face,onClick }) => {

  let classes = useStyles();
  let hollowClassName = solid===false ?  `${classes.hollow} no-shadow` : '';
  let flatClassName = flat ?  `${classes.flat} no-shadow` : '';
  let titleBetweenClassName = titleBetween ?  `${classes.titleBetween}` : '';
  let faceClassName = !flat && face ? "shadow-xs c-l" : "";

  return (
    <Widget className={`${hollowClassName} ${flatClassName} ${titleBetweenClassName} ${faceClassName} ${className}`} onClick={onClick}>
      <BoardTitle left={left} title={title} to={to} toClick={toClick} icon={icon} iconColor={iconColor} iconClassName={iconClassName} className={titleContainerClassName} titleClassName={titleClassName} line={titleLine} />
      {solid===false ? <Divider className={"c-mb-20px"} /> : null}
      <BoardBody className={bodyClassName} children={children} emptyClassName={emptyClassName} empty={empty} tip={tip} go={go} goClick={goClick} />
    </Widget>
  )
}

Board.defaultProps={
  titleClassName:"c-text-s2",
  bodyClassName:"",
  className:'',
  iconClassName:'',
  solid:true,
  flat:false,
  face:true
}



const BoardTitle = ({ left, title, to,toClick, icon,iconColor,className,iconClassName,titleClassName,line,titleBetween }) => {


  const renderTitle = ()=>{
    if(!icon && !title && !left) return null;
    return (
      <div className="d-flex flex-row justify-content-start align-items-center">
        {icon?createIcon(icon,`c-icon-s2 mr-2 ${iconColor||'text-primary'} ${iconClassName}`):null}
        {left}
        <h3 className={`card-title mb-0 c-lh-1 ${titleClassName||''}`}>{title}</h3>
      </div>
    );
  }
  
  let titleComponent = renderTitle();
  let toolComponent = renderTool(to,toClick);

  return (
    titleComponent||toolComponent?(
      <div className={`d-flex flex-column mb-3 ${className}`}>
        <div className={`d-flex flex-row justify-content-between align-items-center ${line?'pb-3 c-lb':''}`}>
          {titleComponent}
          {toolComponent}
        </div>
        {/* {line?<Divider className="c-mt-20px" />:null} */}
      </div>
    ):null
  )
}

BoardTitle.defaultProps={
  className:'',
  titleClassName:"c-text-s2",
  iconClassName:''
}


const BoardBody = ({ children, empty, tip,go, goClick,className,emptyClassName }) => {

  return (
    [
      <div key={0} className={`d-flex flex-column c-flex-1 ${className}`} >
        {
          children ? children :
          <div className="d-flex flex-row justify-content-start align-items-center">
            <p className={`mb-0 m-text-muted ${emptyClassName}`}>{empty}</p>
          </div>
        }
      </div>
    ,
      tip||go?
      (<div key={1} className="d-flex justify-content-between align-items-end">
        <div>{tip}</div>
        {renderTool(go,goClick)}
      </div>)
      :null
    ]
  )
}

BoardBody.defaultProps={
  className:'',
  emptyClassName:"c-text-s2"
}

const Section = ({ title,left, description,className,titleClassName,line,tools }) => {

  return (
    <div className={`d-flex flex-column justify-content-center align-items-start ${className}`}>
        <div className="d-flex flex-row justify-content-between align-items-center w-100">
          <div className="d-flex flex-row justify-content-start align-items-center">
            {left?left:null}
            <h3 className={`card-title mb-0 ${titleClassName}`}>{title}</h3>
          </div>
          {tools?<div>{tools}</div>:null}
        </div>
        {line?<Divider className="w-100 my-2" />:null}
    </div>
  )
}

Section.defaultProps={
  className:'',
  titleClassName:'c-text-s2'
}



export {Board,BoardTitle,BoardBody,Section};